import { Grid, Card, Typography, Link } from '@mui/material'
import colors from '../../../colors';
import { ReactComponent as BankTransferLogo } from '../../../../icons/bankTransferLogoSmall.svg';
import React from 'react'
import SingleBankTransfer from './SingleBankTransfer';
import { useSelector, useDispatch } from 'react-redux';
import {selectTopUpData} from '../../../../features/userInfo/topUpSlice'
import { sendGeneralRequest } from '../../../../features/generalRequest'
import { makeStyles } from '@mui/styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { texts } from '../../../general/texts'

export const BankTransfer = () => {
    
    const topUpDataSliceState = useSelector(selectTopUpData)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    React.useEffect(()=>{
        dispatch(sendGeneralRequest({request: {}, baseUrlKey:'services', endpoint:'GetBanksIban'}))
    },[])

    const useStyles = makeStyles({
        card:{
            borderRadius:'20px',
            width:'50%',
            boxShadow:'0 0 15px 5px #E5E7EA',
            '@media (max-width: 1440px)' : {width:'60%'}, 
            '@media (max-width: 1024px)' : {width:'80%'},
            '@media (max-width: 699px)' : {width:'90%'}
        },
        header:{
            color:colors.darkBlue,
            fontFamily:'GerberaBold',
            fontSize:'1.5rem',
            paddingLeft:'3%',
            paddingTop:'1%',
            fontSize:'1.5rem'
        }
        
      })
    
      const classes = useStyles()

  return (
    <Grid container item md={12} xs={12} justifyContent={'center'} >
        <Card  className={classes.card}>
        <Grid container item md={12} direction="column" pb={10} >
            <Grid container item md={12} xs={12} mt={7} mb={7}>
                <Grid container item md={1} xs={1} direction="row" justifyContent="center" alignItems="center" ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
                <Grid container item md={10} xs={10} direction="row" justifyContent="center" alignItems="center" >
                    <Grid container direction="column" justifyContent="center" alignItems="center" sx={{width:'65px', height:'65px', borderRadius:'20px', background:colors.veryLightBlue}}><BankTransferLogo /></Grid>
                    <Typography color={colors.darkBlue} className={classes.header}>{texts["title-bank-transfer"]}</Typography>
                </Grid>
            </Grid>
            <Grid container item p={2}  columnSpacing={6}>
            { topUpDataSliceState.banksIbanData.map((bankTransfer, index) => {
                return  <Grid container key={index} item md={6} xs={12} pb={'5%'} justifyContent={'center'} >
                            <SingleBankTransfer name={bankTransfer.Key} iban={bankTransfer.Value} key={index}/>
                        </Grid>
            })}
            </Grid>
            </Grid>
        </Card>
    </Grid>
  )
}
export default BankTransfer